import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConsultingTeamMember, ConsultingTeamMemberAssignment } from '../types/consulting-team-member';

@Injectable({ providedIn: 'root' })
export class ConsultingTeamMemberService {
  private teamMembersPath = environment.apiDomain + '/enterprises/consulting-team-members';
  private teamMemberAssignmentsPath = environment.apiDomain + '/enterprises/consulting-team-member-assignments';

  constructor(private http: HttpClient) {}

  // Team Members
  getTeamMembersByConsultingOrganization(consultingOrganizationId: string): Observable<ConsultingTeamMember[]> {
    const url = this.teamMembersPath + `?consultingOrganizationId=${consultingOrganizationId}`;
    return this.http.get<ConsultingTeamMember[]>(url);
  }

  getTeamMembersByEnterprise(enterpriseId: string): Observable<ConsultingTeamMember[]> {
    const url = this.teamMembersPath + `?enterpriseId=${enterpriseId}`;
    return this.http.get<ConsultingTeamMember[]>(url);
  }

  getTeamMembersByFacility(facilityId: string): Observable<ConsultingTeamMember[]> {
    const url = this.teamMembersPath + `?facilityId=${facilityId}`;
    return this.http.get<ConsultingTeamMember[]>(url);
  }

  getTeamMemberById(id: string): Observable<ConsultingTeamMember> {
    const url = this.teamMembersPath + `/${id}`;
    return this.http.get<ConsultingTeamMember>(url);
  }

  // Assignments
  getAssignmentsByConsultingOrganizationId(
    consultingOrganizationId: string,
  ): Observable<ConsultingTeamMemberAssignment[]> {
    const url = this.teamMemberAssignmentsPath + `?consultingOrganizationId=${consultingOrganizationId}`;
    return this.http.get<ConsultingTeamMemberAssignment[]>(url);
  }

  getAssignmentsByTeamMemberId(teamMemberId: string): Observable<ConsultingTeamMemberAssignment[]> {
    const url = this.teamMemberAssignmentsPath + `?teamMemberId=${teamMemberId}`;
    return this.http.get<ConsultingTeamMemberAssignment[]>(url);
  }

  createAssignment(assignment: ConsultingTeamMemberAssignment): Observable<ConsultingTeamMemberAssignment> {
    const url = this.teamMemberAssignmentsPath;
    return this.http.post<ConsultingTeamMemberAssignment>(url, assignment);
  }

  updateAssignment(assignment: ConsultingTeamMemberAssignment): Observable<void> {
    const url = this.teamMemberAssignmentsPath;
    return this.http.put<void>(url, assignment);
  }

  deleteAssignment(id: string): Observable<void> {
    const url = this.teamMemberAssignmentsPath + `/${id}`;
    return this.http.delete<void>(url);
  }
}
